import React, { useState, useEffect, useRef, useCallback } from "react";
import { GoogleApiWrapper, Map } from "google-maps-react";

const PickupPointMap = ({ google, latitude, longitude, onLocationSelect }) => {
  const mapInstanceRef = useRef(null);
  const listenerRef = useRef(null);
  const [coords, setCoords] = useState({ lat: latitude, lng: longitude });

  useEffect(() => {
    setCoords({ lat: latitude, lng: longitude });
  }, [latitude, longitude]);

  const onMapReady = useCallback((mapProps, map) => {
    mapInstanceRef.current = map;
    listenerRef.current = google.maps.event.addListener(map, "center_changed", () => {
      const c = map.getCenter();
      const lat = c.lat();
      const lng = c.lng();
      setCoords({ lat, lng });
      onLocationSelect(lat, lng);
    });
  }, [google, onLocationSelect]);

  useEffect(() => {
    return () => {
      if (listenerRef.current) {
        google.maps.event.removeListener(listenerRef.current);
      }
    };
  }, [google]);

  return (
    <div style={{ width: "100%", height: "250px", position: "relative", borderRadius: 8, overflow: "hidden", border: "1px solid #ddd" }}>
      <Map
        google={google}
        zoom={14}
        initialCenter={latitude ? { lat: latitude, lng: longitude } : { lat: 11.5564, lng: 104.9282 }}
        onReady={onMapReady}
        containerStyle={{ position: "relative", width: "100%", height: "100%" }}
        style={{ position: "relative", width: "100%", height: "100%" }}
        disableDefaultUI={true}
        gestureHandling="greedy"
      />
      {/* Fixed center pin overlay */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -100%)",
          pointerEvents: "none",
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <svg width="32" height="42" viewBox="0 0 32 42" fill="none">
          <path d="M16 0C7.16 0 0 7.16 0 16c0 12 16 26 16 26s16-14 16-26C32 7.16 24.84 0 16 0z" fill="#E53935"/>
          <circle cx="16" cy="16" r="6" fill="white"/>
        </svg>
        <div
          style={{
            marginTop: 2,
            background: "white",
            borderRadius: 4,
            padding: "2px 6px",
            fontSize: 11,
            fontWeight: 600,
            whiteSpace: "nowrap",
            boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
          }}
        >
          {coords.lat.toFixed(5)}, {coords.lng.toFixed(5)}
        </div>
      </div>
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
  libraries: ["places"],
})(PickupPointMap);
